import React, {useRef, useState} from 'react'
import Paper from "@material-ui/core/Paper/Paper";
import TextField from "@material-ui/core/TextField/TextField";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import {useSignIn} from "../services/auth";
import {makeStyles} from "@material-ui/styles";

export default function SignInFrom() {

    const signIn = useSignIn();
    const phoneRef = useRef();
    const passRef = useRef();

    const [error, setError] = useState(false);


    async function handleSubmit() {
        const done = await signIn(phoneRef.current.value, passRef.current.value);
        setError(!done)
    }

    const classes = useStyles();


    return (
        <Paper variant="outlined" className={classes.root}>
            <form>
                <div className={classes.input}>
                    <TextField label="شماره تلفن" variant="filled" size="small" type="tel" fullWidth
                               inputRef={phoneRef}/>
                </div>
                <div className={classes.input}>
                    <TextField label="رمز عبور" variant="filled" size="small" type="password" fullWidth
                               inputRef={passRef}/>
                </div>
                <Button variant="contained" color="primary" className={classes.button}
                        fullWidth onClick={handleSubmit}>ورود</Button>
            </form>

            <Typography color="textSecondary" variant="subtitle2" className={classes.text}>
                پنل مدیریت تامین | فروش |‌ ضمانت <b>افاق‌تل</b>
            </Typography>
        </Paper>
    )
}

const useStyles = makeStyles(theme => ({

    root: {
        textAlign: 'center',
        padding: theme.spacing(10, 10, 3, 10),
        borderColor: theme.palette.primary.main
    },
    input: {
        margin: theme.spacing(2, 0),
    },
    button: {
        marginTop: theme.spacing(4),
        color: 'white'
    },
    text: {
        marginTop: theme.spacing(10)
    }
}));
